import { render, staticRenderFns } from "./TreeAncestor.vue?vue&type=template&id=3dc7545d&scoped=true&"
import script from "./TreeAncestor.vue?vue&type=script&lang=js&"
export * from "./TreeAncestor.vue?vue&type=script&lang=js&"
import style0 from "./TreeAncestor.vue?vue&type=style&index=0&id=3dc7545d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7545d",
  null
  
)

export default component.exports